export default "__VITE_ASSET__BlUy_rDf__"